import React from 'react'

import { bool, oneOf, string } from 'prop-types'

function StepIndicator({ position = 'first', stepNumber, highlightStep = false }) {
  return (
    <div className="custom-solutions__step-number-container">
      {position !== 'first' && (
        <div
          className={`
          custom-solutions__step-number-line
          custom-solutions__step-number-line--top
        `}
        />
      )}

      <span className="custom-solutions__step-number">{stepNumber}</span>

      {(position === 'first' || position === 'middle') && (
        <div
          className={`
          custom-solutions__step-number-line
          custom-solutions__step-number-line--bottom
          ${
            highlightStep ? 'custom-solutions__step-number-line--highlight' : ''
          }
        `}
        />
      )}
    </div>
  )
}

StepIndicator.propTypes = {
  position: oneOf(['first', 'middle', 'last']),
  stepNumber: string.isRequired,
  highlightStep: bool,
}

export default StepIndicator
